import React from 'react';
import Layout from '../../components/Layout/Layout'
import Iso from '../../components/iso50001/Iso'
import styles from '../../style/iso50001.module.css'

export default function iso50001() {

    return (
        <Layout>
            
            <Iso/>
            <div className={styles.container}>
                <div className={styles.layout}>
                    <div className={styles.wrapper}>
                        
                       <div className={styles.course_iso}>
                       <h1 className="title"><span className="underline">ISO-50001:2018 СТАНДАРТЫН ЗӨВЛӨХ ҮЙЛЧИЛГЭЭ</span></h1>
                                <ul>
                                    <li>
                                        <b>Ажлын нэр:  </b> “ЭРЧИМ ХҮЧНИЙ УДИРДЛАГЫН ТОГТОЛЦООНЫ MNS ISO-50001:2018 СТАНДАРТ”-ЫН ОРЧУУЛГА
                                    </li>
                                    <li>
                                        <b>Захиалагч: </b>  Обсерв ХХК
                                    </li>
                                    <li>
                                        <b>Оролцоо: </b> Туслан гүйцэтгэгч
                                    </li>
                                    <li>
                                        <b>Хэрэгжүүлсэн огноо: </b>2019 оны 7-р сар
                                    </li>
                                    <li>
                                        <b>Гүйцэтгэсэн ажил:</b> Хавсралт-А “Стандартыг хэрэгжүүлэх аргачлал”
                                    </li>
                                </ul>
                                <hr/>
                                <ul>
                                    <li>
                                        <b>Ажлын нэр:  </b> “TЕСО МИЛКО ҮЙЛДВЭРТ ISO-50001:2018 СТАНДАРТ ХЭРЭГЖҮҮЛЭХ ТӨСӨЛ” 
                                    </li>
                                    <li>
                                        <b>Захиалагч: </b>  Обсерв ХХК
                                    </li>
                                    <li>
                                        <b>Оролцоо: </b> Туслан гүйцэтгэгч
                                    </li>
                                    <li>
                                        <b>Хэрэгжүүлсэн огноо: </b>2019 оны 8-р сар
                                    </li>
                                    <li>
                                        <b>Гүйцэтгэсэн ажил:</b> “TЕСО МИЛКО үйлдвэрт ISO-50001:2018 стандарт хэрэгжүүлэх төсөл”-ийн хүрээнд дотоод аудиторуудад зориулж “Компрессорын ажиллагааны хяналтын хуудас” боловсруулсан
                                    </li>
                                </ul>
                            
                            
                            <hr/>
                            <ul>
                                    <li>
                                        <b>Ажлын нэр:  </b> “ЭРЧИМ ХҮЧНИЙ ХЭМНЭЛТ БА ҮР АШИГ” СЕМИНАР
                                    </li>
                                    <li>
                                        <b>Захиалагч: </b>  Обсерв ХХК
                                    </li>
                                    <li>
                                        <b>Оролцоо: </b> Семинар зохион байгуулах ажлын хэсгийн гишүүн, Модератор, Илтгэгч
                                    </li>
                                    <li>
                                        <b>Хэрэгжүүлсэн огноо: </b>2019 оны 10-р сарын 23-ны өдөр
                                    </li>
                                    <li>
                                        <b>Гүйцэтгэсэн ажил:</b> 
                                        <ul className={styles.sublist}>
                                            <li>
                                            Семинарыг угтаж ISO-50001:2018 стандартыг олон нийтэд таниулан суртачлах мэдлэг хуваалцах уулзалтыг 2019 оны 8-9-р саруудад 3 удаа зохион байгууллаа. 
                                            </li>
                                            <li>
                                            Семинарт оролцогчид, илтгэгч нар, ивээн тэтгэгч, шийдвэр гаргагч байгууллагуудыг Обсерв ХХК-тай холбоо тогтоож; 
                                            </li>
                                            <li>
                                            “ISO-50000 бүлгийн стандарт” илтгэл тавьж;
                                            </li>
                                            <li>
                                            	“Үүрэг хүлээсэн хэрэглэгчдэд Эрчим хүчний удирдлагын тогтолцооны стандарт нэвтрүүлэхэд тулгамдаж буй асуудал, шийдвэрлэх арга зам” сэдвээр хэлэлцүүлэгийг удирдав. 
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <hr/>
                                <ul>
                                    <li>
                                        <b>Ажлын нэр:  </b> ISO-50001:2018 СТАНДАРТЫН МЭДЛЭГ ХУВААЛЦАХ УУЛЗАЛТУУД
                                    </li>
                                    <li>
                                        <b>Захиалагч: </b>  Обсерв ХХК
                                    </li>
                                    <li>
                                        <b>Оролцоо: </b> Сургагч багш
                                    </li>
                                    <li>
                                        <b>Хэрэгжүүлсэн огноо: </b>2019 оны 8-9-р саруудад
                                    </li>
                                    <li>
                                        <b>Гүйцэтгэсэн ажил:</b>ISO-50001:2018 стандартыг олон нийтэд таниулан суртачлах, татан оролцуулах зорилгоор Эрчим хүчний удирдлагын тогтолцооны ISO-50001:2018 стандартын бүтэц, агуулга, зорилго, түүнийг хэрэгжүүлэх шаардлага, ач холбогдол, эрчим хүчний аудитаас ялгагдах ялгаа зэргийг тайлбарлав.
                                    </li>
                                </ul>
                            </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
